import { motion } from "framer-motion";

// Scroll-triggered reveal wrapper
export const Reveal = ({ children, delay = 0, y = 28, className = "", ...rest }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}
    className={className}
    {...rest}
  >
    {children}
  </motion.div>
);

export const SectionHeading = ({ eyebrow, title, subtitle, align = "center" }) => (
  <div className={`max-w-3xl ${align === "center" ? "mx-auto text-center" : ""}`}>
    {eyebrow && (
      <Reveal>
        <div className={`mb-4 flex items-center gap-3 ${align === "center" ? "justify-center" : ""}`}>
          <span className="h-px w-8 bg-tt-gold/70" />
          <span className="font-grotesk text-xs uppercase tracking-[0.3em] text-tt-gold">{eyebrow}</span>
          <span className="h-px w-8 bg-tt-gold/70" />
        </div>
      </Reveal>
    )}
    <Reveal delay={0.05}>
      <h2 className="font-display text-4xl font-semibold leading-tight sm:text-5xl">
        <span className="metallic-text">{title}</span>
      </h2>
    </Reveal>
    {subtitle && (
      <Reveal delay={0.1}>
        <p className="mt-5 text-base text-tt-silver/60 sm:text-lg">{subtitle}</p>
      </Reveal>
    )}
  </div>
);
